export const initialState = {
    // REMOVED: config state - React Query is now the single source of truth
    player: {
        isMuted: true,
    },
    revision: {
        flRev: 0,
        subRev: 0,
        prev: 0,
        consentRev: null,
    },
    profile: {
        isSecondaryProductOpen: true,
        profilesLimit: 5,
        profileList: null,
        selectedProfile: {
            defaultSubTitleLang: 'ar',
            defaultAudioLang: 'en',
            parentalControlValues: { 0: 'G', 1: 'PG', 2: 'PG12', 3: 'PG15', 4: 'R15', 5: 'R18' },
            autoPlayNextEpisode: true,
            profilePasssword: '',
        },
        dispatchedActions: {
            action: false,
            message: false,
        },
        isLoading: false,
        isFormSubmitted: false,
        errMess: false,
        errCode: false,
        passwordVerifying: {
            isLoading: false,
            errMess: null,
            errCode: null,
        },
    },
    watchlist: {
        detailedWatchlist: null,
        isLoading: false,
        watchlist: [],
        errMess: null,
    },
    liveTv: {
        userChannels: {
            channels: [],
            genres: [],
        },
        isLoading: false,
        errMess: null,
    },
    bookmarks: {
        isLoading: false,
        bookmarks: [],
        errMess: null,
    },
    search: {
        searchQuery: '',
        filter: 'all',
        recommendations: [],
        all: [],
        vod: [],
        live: [],
        rewind: [],
        person: [],
        error: null,
        isLoading: false,
        lastFetched: 0,
    },
    header: {
        searchOverlay: false,
    },
    screenHistory: [],
    user: {
        tvodList: [],
    },
    location: {},
    miniEpg: {
        userProfileChannels: [],
        isLoading: false,
        errMess: null,
        data: {},
    },
    overlay: {
        isVisible: false,
        screen: '',
    },
    parentalPin: {
        isLoading: false,
        errCode: false,
        errMsg: false,
        successMsg: false,
        pin: '',
        canRedirect: false,
        step: '',
        response: null,
        verificationGuid: '',
    },
    // used when landing on details (series/movie)
    contentDetails: {
        content: null,
        episodes: [],
        vodGuid: null,
    },
    // subscriptionTiers: {},
    reminder: {
        remindersData: [],
        isLoading: false,
        errMess: null,
        showPanel: false,
        state: '', // set | unset | errorSet | errorUnset
        item: {},
        currentIndex: null,
    },
    generalConfiguration: {
        showUpgradedModal: false,
        showGuestRedirectModal: false,
        upgradeModalFromNoAdsCta: false,
        noAdsCtaSource: null,
        ppvEventConfig: null,
        // REMOVED: promotions moved to React Query configuration
        // promotions: [],
    },
    moodsRecommendation: {
        moodType: null,
        moodCategory: null,
    },
    movieOverlay: {
        isVisible: false,
        isCatchupVisible: false,
        isPpvVisible: false,
    },
    favorite: {
        favoritesData: [],
        isLoading: false,
        errMess: null,
        currentIndex: null,
    },
    profileAvatars: {},
    castCrewModal: {
        isOpen: false,
        modalContent: null,
    },
};
